import { RiKey2Line } from '@remixicon/react';

import { AzureSubscription } from '../../types/azureSubscription';
import { AzureResourceLinks } from './AzureResourceLinks';

type AzureSubscriptionsProps = {
  subscriptions: AzureSubscription[];
};

export const AzureSubscriptions = ({ subscriptions }: AzureSubscriptionsProps) => {
  return (
    <AzureResourceLinks
      label="Subscriptions"
      emptyText="No subscriptions found"
      icon={<RiKey2Line size={16} aria-hidden="true" focusable="false" />}
      resourceType="subscriptions"
      resources={subscriptions}
    />
  );
};
